export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvSwitch.vue?vue&type=template&id=dfe65a72&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSwitch.vue?vue&type=template&id=dfe65a72&lang=pug&
// module id = 140
// module chunks = 0 1